import { render, staticRenderFns } from "./HsabExpenseFormSchedule.vue?vue&type=template&id=dec029b2&scoped=true"
import script from "./HsabExpenseFormSchedule.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseFormSchedule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec029b2",
  null
  
)

export default component.exports